AppView.$inject = [];
function AppView() {
    return {
        template: require('./views/main.html'),
        controller: function () {
        },
        link: function (scope, elem, attrs, ctrl) {
        }
    };
}
angular.module('profumo.core.main.view', [])
    .directive('appView', AppView);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/main/view.ts
// module id = 448
// module chunks = 0